import axios from "axios";

import { ElLoading } from 'element-plus/es';
import 'element-plus/es/components/base/style/css';
import 'element-plus/es/components/loading/style/css';
export default {
  data() {
    return {
      institution: sessionStorage.getItem("institution"),
      page: 1,
      pageSize: 10,
      operationLogList: [],
      //搜索
      inputClassName: "",
      selectedDate: "",
      showSearchResult: false
    };
  },
  async mounted() {
    await this.getOperationLog();
  },
  methods: {
    async getOperationLog() {
      //loading界面
      const loading = ElLoading.service({
        lock: true,
        text: "处理中...",
        background: "rgba(0, 0, 0, 0.7)"
      });
      try {
        let params = {
          page: this.page,
          pageSize: this.pageSize,
          institution: this.institution
        };
        // 如果是搜索
        if (this.showSearchResult) {
          params["isSearch"] = true;
          params["searchParams"] = {
            className: this.inputClassName,
            date: this.selectedDate
          };
        }
        let resp1 = await axios.post("https://backend.wonology.com/courseArrange/operationLog/getOperationLog", params);
        if (resp1.data.code == "0000") {
          this.operationLogList = resp1.data.data;

          // console.log("this.operationLogList:", this.operationLogList);
        } else {
          console.log("调用后端出错:", resp1.data.msg);
          alert("调用后端出错: " + resp1.data.msg);
        }
      } catch (error) {
        console.log("catch error:", error);
        alert("catch error");
      } finally {
        loading.close();
      }
    },
    async search() {
      this.showSearchResult = true;
      this.page = 1;
      this.pageSize = 10;
      await this.getOperationLog();
    },
    async cancelSearch() {
      this.showSearchResult = false;
      this.page = 1;
      this.pageSize = 10;
      await this.getOperationLog();
    },
    async handlePageSizeChange() {
      this.page = 1;
      await this.getOperationLog();
    },
    async previousPage() {
      if (this.page == 1) {
        return;
      } else {
        this.page = this.page - 1;
        await this.getOperationLog();
      }
    },
    async nextPage() {
      let totalPage = Math.ceil(this.operationLogList.totalNum / this.pageSize);
      if (this.page == totalPage) {
        return;
      } else {
        this.page = this.page + 1;
        await this.getOperationLog();
      }
    },
    async toPage() {
      await this.getOperationLog();
    }
  }
};